import React from "react"

const Facebook = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16.875" cy="16.75" r="16.75" fill="#34A0B6" />
      <path
        d="M19.8023 12.0477H21.2418V9.67597C20.5448 9.60538 19.8445 9.57052 19.1438 9.57156C17.061 9.57156 15.6368 10.8097 15.6368 13.077V15.0311H13.2861V17.6863H15.6368V24.4884H18.4546V17.6863H20.7977L21.1499 15.0311H18.4546V13.338C18.4546 12.5549 18.669 12.0477 19.8023 12.0477Z"
        fill="white"
      />
    </svg>
  )
}

export default Facebook
